import { Routes, Route } from "react-router-dom";
import { MovieList, MovieDetail, Search, PageNotFound } from "../pages";
import moviesData from "../data/movies.json";

export const AllRoutes = () => {
  return (
    <div className="dark:bg-darkbg">
        <Routes>
            <Route path="" element={<MovieList movies={moviesData} title="Home" />} />
            <Route path="movie/:id" element={<MovieDetail movies={moviesData} />} />
            <Route path="movies/popular" element={<MovieList movies={moviesData} filter="popular" title="Popular" />} />
            <Route path="movies/top" element={<MovieList movies={moviesData} filter="top" title="Top Rated" />} />
            <Route path="movies/upcoming" element={<MovieList movies={moviesData} filter="upcoming" title="Upcoming" />} />
            <Route path="search" element={<Search movies={moviesData} />} />
            <Route path="*" element={<PageNotFound />} />
        </Routes>
    </div>
  );
};
